'use strict';

angular.module('utils').factory('OCSocialUtil', function($timeout) {
  return {
    addthisToolbox: function(target) {
      if (window.addthis) {
        $timeout(function() {
          addthis.toolbox(target);
        }, 300);
      }
    },
  };
});
